import { FieldProps } from "@/core/components/Field";
import { Box } from "@mui/system";
import { Theme, Typography } from "@mui/material";
import { useGetPreviousAnswers } from "@/core/hooks/useGetPreviousAnswers/useGetPreviousAnswers";
import { useTranslations as t } from "@/core/hooks/useTranslations/useTranslations";
import { HeadingLevel } from "@/core/types/types";
import useCustomStyles from "@/core/hooks/useCustomStyles/useCustomStyles";

const styles = (theme: Theme) => ({
  root: {
    backgroundColor: theme.palette.background.paper,
    padding: theme.spacing(2),
    "& > :first-child": {
      marginBottom: theme.spacing(2),
    },
  },
  fullNameWrapper: {
    display: "flex",
    flexDirection: "row",
    marginBottom: theme.spacing(1),
  },
  namePartWrapper: {
    width: "50%",
    marginBottom: theme.spacing(1),
  },
});

const CustomerContactInfo = ({ field }: FieldProps) => {
  const {
    properties: { requiredInputVariables },
  } = field;

  if (!requiredInputVariables) {
    throw new Error("Missing required input variable names.");
  }

  const { result } = useGetPreviousAnswers(requiredInputVariables);

  const { customerFirstName, customerLastName, customerEmail } = result;
  const classes: any = useCustomStyles(styles);

  return (
    <Box sx={classes?.root}>
      <Typography variant={HeadingLevel.H3}>
        {t("customerContactInfo.title")}
      </Typography>
      <Box sx={classes?.fullNameWrapper}>
        <Box sx={classes?.namePartWrapper}>
          <Typography variant={HeadingLevel.Body2}>
            {t("customerContactInfo.firstName")}
          </Typography>
          <Typography variant={HeadingLevel.Subtitle1}>
            {customerFirstName}
          </Typography>
        </Box>
        <Box sx={classes?.namePartWrapper}>
          <Typography variant={HeadingLevel.Body2}>
            {t("customerContactInfo.lastName")}
          </Typography>
          <Typography variant={HeadingLevel.Subtitle1}>
            {customerLastName}
          </Typography>
        </Box>
      </Box>
      <Box>
        <Typography variant={HeadingLevel.Body2}>
          {t("customerContactInfo.email")}
        </Typography>
        <Typography variant={HeadingLevel.Subtitle1}>
          {customerEmail}
        </Typography>
      </Box>
    </Box>
  );
};

export default CustomerContactInfo;
